import { render } from "./PasswordlessConfirmModal.vue?vue&type=template&id=23650fe4"
import script from "./PasswordlessConfirmModal.vue?vue&type=script&lang=js"
export * from "./PasswordlessConfirmModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__